<template>
  <div class="container-fluid max-container" style="overflow-x: hidden;">
    <div class="row">
      <div class="col-12 p-0">
        <Header />
      </div>
      <page-loader v-if="loadingStatus === 'loading'" />
      <section v-else-if="loadingStatus === 'loaded'" class="result-wrapper col-12">
        <div class="container">
          <div class="row">
            <!-- Show ONLY on baker overview -->
            <div class="col-12" v-if="showNavigation">
              <BakersNavigation />
            </div>
            <div class="col-12">
              <router-view :baker-result="bakersResult" />
            </div>
          </div>
        </div>
      </section>
      <div class="col-12" v-else>
        <BakersStatus :status="loadingStatus" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import store from "@/store/index";
import Header from "@/components/header/Header.vue";
import BakersStatus from "@/view/bakers/BakersStatus.vue";
import BakersNavigation from "@/view/bakers/BakersNavigation.vue";

import { getBakersResult } from "@/services/bakers";

const actions = {
  completed: (loadingStatus, bakersResult) => {
    getBakersResult(store.getters.profile.profile.barcode)
      .then((res) => {
        bakersResult.value = res;
        loadingStatus.value = "loaded";
      })
      .catch((e) => {
        console.error(e);
        loadingStatus.value = "loadingFailed";
      });
  },
  // A test being updated to a new version keeps its previous results meanwhile
  updating: (loadingStatus, bakersResult) => actions.completed(loadingStatus, bakersResult),
  error: (loadingStatus) => {
    loadingStatus.value = "testErrored";
  },
  failed: (loadingStatus) => {
    loadingStatus.value = "testFailed";
  },
  pending: (loadingStatus) => {
    loadingStatus.value = "resultPending";
  },
  noData: (loadingStatus) => {
    loadingStatus.value = "testNoData";
  },
  processing: (loadingStatus) => {
    loadingStatus.value = "resultPending";
  },
};

export default {
  name: "Bakers-main",
  components: {
    Header,
    BakersNavigation,
    BakersStatus,
  },

  setup() {
    const route = useRoute();
    const loadingStatus = ref("loading");
    const bakersResult = ref({});
    const showNavigation = computed(() => {
      return route.name === "bakers-overview";
    });

    // A status this page doesn't know reads as still being processed, not a loader for good
    const showStatus = () => {
      const baker = store.getters.kitTests?.baker;
      if (!baker) {
        loadingStatus.value = "loadingFailed";
      } else if (!baker.purchased) {
        loadingStatus.value = "notPurchased";
      } else {
        (actions[baker.status] ?? actions.pending)(loadingStatus, bakersResult);
      }
    };
    // The kit's tests are missing when they failed to load on the way in: ask for them again
    if (store.getters.kitTests?.baker) {
      showStatus();
    } else {
      store.dispatch("SET_KIT_TESTS", store.getters.profile?.profile?.barcode).catch(() => {}).finally(showStatus);
    }
    return {
      loadingStatus,
      bakersResult,
      showNavigation,
    };
  },
};
</script>
<style lang="scss" scoped>
.baker-nav {
  padding-inline: 0;
}
</style>